import Index from "@/views/Apps/Translations/Index";
import Activation from "@/views/Apps/Translations/Activation";
import Home from "@/views/Apps/Translations/Home";
import Agents from "@/views/Apps/Translations/Agents";
import Analytics from "@/views/Apps/Translations/Analytics";
import Settings from "@/views/Apps/Translations/Settings";
import Subscription from "@/views/Apps/Translations/Subscription";

export default [
  {
    path: "/apps/translations",
    name: "Translations",
    component: Index,
    redirect: "/apps/translations/home",
    children: [
      {
        path: "home",
        name: "Home",
        component: Home,
      },
      {
        path: "analytics",
        name: "Analytics",
        component: Analytics,
      },
      {
        path: "settings",
        name: "Settings",
        component: Settings,
      },
      {
        path: "Agents",
        name: "Agents",
        component: Agents,
      },
      {
        path: "subscription",
        name: "Subscription",
        component: Subscription,
      },
    ],
  },

  {
    path: "/apps/translations/activation",
    name: "Activation",
    component: Activation,
  },
];
